const overrides = [
  'debug',
  'info',
  'log',
  'warn',
  'error',
  'table',
  'group',
  'groupCollapsed',
  'groupEnd',
];
const scopeColors = new Map();
const loggers = new Map();

let lsDebugRules;

try {
  lsDebugRules = localStorage.debug;
} catch (error) {
  console.log(error);
}

let rules = createRules(lsDebugRules);
window.addEventListener('storage', onStorageUpdate);

export default scopeLogger;

/**
 * Return `globalThis.console` equal object, having
 * @param {string} prefix scope name
 * @return {{[p: string]: Function}}
 */
function scopeLogger(prefix) {
  if (!loggers.has(prefix)) {
    loggers.set(prefix, createLogger(prefix));
  }

  return loggers.get(prefix);
}

function onStorageUpdate(event) {
  if (event.key === null) {
    rules = [];
  }
  if (event.key !== 'debug') {
    return;
  }

  rules = createRules(event.newValue);
  loggers.forEach((_logger, prefix) => {
    loggers.set(prefix, createLogger(prefix));
  });
}

function createRules(rulesString = '') {
  if (rulesString === 'false') {
    return [];
  }

  return rulesString
    .split(',')
    .map((rule) => rule.trim())
    .filter(Boolean)
    .map((rule) => {
      const negate = rule[0] === '-' || rule[0] === '!';
      const patternString = rule.replace('*', '.*').replace(/^[-!]/, '');
      const pattern = new RegExp(`^${patternString}$`, 'i');
      return (string) => {
        const matched = pattern.test(string);
        return matched ? !negate : undefined;
      };
    });
}

function createLogger(prefix) {
  const enable = rules.reduce((tEnable, rule) => {
    const result = rule(prefix);
    return result === undefined ? tEnable : result;
  }, false);
  const prefixColor = getScopeColor(prefix);

  if (process.env.NODE_ENV === 'development') {
    const message = enable ? 'Create %c%s%c logger' : 'Disable log for %c%s%c';
    console.debug(message, `color:${prefixColor}`, prefix, 'color:default');
  }

  const _console = { prefix, isEnable: enable };

  for (const name in window.console) {
    const appliedProperty = overrides.includes(name)
      ? window.console[name].bind(
          console,
          `%c${prefix}%c %s`,
          `font-weight:bold;color:${prefixColor}`,
          'font-weight:default;color:default',
        )
      : function () {
          window.console[name].apply(window.console, arguments);
        };

    Object.defineProperty(_console, name, {
      get() {
        /*
        todo: merge passed format string with prefix ...
         const args = [
          typeof arg === 'string' ? `%c${prefix}%c ${arg}` : `%c${prefix}%c`,
          `font-weight:bold;color:${prefixColor}`,
          'font-weight:default;color:default',
          typeof arg !== 'string' ? arg : '',
          ...rest
          ];

          and keep invoke pointer untouched, e.g. do not grab console line into scope-logger
         */
        if (enable) {
          return appliedProperty;
        }
        return Function.prototype;
      },
    });
  }

  return _console;
}

function getScopeColor(prefix) {
  if (scopeColors.has(prefix) === false) {
    scopeColors.set(prefix, randomColor());
  }
  return scopeColors.get(prefix);
}

let hueDirection = 0;
/**
 * @see {@link https://gist.github.com/bendc/76c48ce53299e6078a76}
 * @return {string}
 */
function randomColor() {
  const hue = hueDirection + randomInt(0, 10);
  hueDirection = (hueDirection + 10) % 360;
  const saturation = randomInt(80, 100);
  const light = randomInt(30, 40);
  return `hsl(${hue},${saturation}%,${light}%)`;
}

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
